import axios from 'axios';

export default {
  install(app, options) {
    const apiDomain = options.apiDomain

    app.config.globalProperties.$beneficiaryService = {
      /**
       * Get beneficiaries from API using custom query params
       */
      async searchWithParams(params) {
        if (params) {
          params.region = options.region
        }

        return await axios.get(apiDomain + '/v1/beneficiaries/search', {
          params: params
        })
      },

      /**
       * Get beneficiaries from API for a specific event
       */
      async searchByEvent(eventCampaignId, tags) {
        var params = {
          eventcampaignid: eventCampaignId,
        }

        if (tags && tags.length > 0)
          params.tags = tags
        return await this.searchWithParams(params)
      },

      /**
       * Get beneficiary details by Id
       */
      async getBeneficiaryById(beneficiaryId) {
        return await this.searchWithParams({
          beneficiaryid: beneficiaryId
        })
      },

      /**
       * get beneficiary for tiers
      */
      async getbeneficiaryForTiers(query, maxResultsToDisplay) {
        query.pagesize = maxResultsToDisplay
        query.pageindex = 1

        return await this.searchWithParams(query)
      },
    }
  }
}